import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IncidentRiskAreaDto, IncidentEventTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-incident-risk-area',
  templateUrl: './incident-risk-area.component.html',
  styleUrls: ['./incident-risk-area.component.scss']
})
export class IncidentRiskAreaComponent implements OnChanges {

  incidentRiskAreaForm: FormGroup;
  incidentRiskAreaFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentRiskAreas: IncidentRiskAreaDto[] = [];
  @Input() eventTypes: IncidentEventTypeDto[] = [];
  @Input() routeAnimationsElements: any;
  @Output() incidentRiskArea = new EventEmitter<IncidentRiskAreaDto[]>()
  @Output() deleteIncidentRiskAreaEvent = new EventEmitter<any>()

    selectedIncidentRiskArea: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    EventName: string;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createIncidentRiskAreaForm();

    }

    createIncidentRiskAreaForm() {
      this.incidentRiskAreaForm = this.fb.group({
        RiskAreaName: ['', Validators.required],
        RiskAreaDescription: [''],
        IncidentEventTypeId: [''],
        EventName: [''],
        id: null
        });
        this.incidentRiskAreaFormArray = this.fb.group({ IncidentRiskAreas: this.fb.array([])
          });
        this.setIncidentRiskArea();
    }

  // method to display IncidentRiskArea
  setIncidentRiskArea() {
    const control  = this.incidentRiskAreaFormArray.controls.IncidentRiskAreas as FormArray;
    this.incidentRiskAreas.forEach( e => {
      control.push(
        this.fb.group({
          RiskAreaName: e.RiskAreaName,
          RiskAreaDescription: e.RiskAreaDescription,
          IncidentEventTypeId: e.IncidentEventTypeId,
          EventName: e.EventName,
          id: e.id
        })
      );
    });
  }

  // onSelectRiskArea(id: string) {
  //   this.EventName = this.eventTypes.find(uom => uom.id === id)?.EventName || null;

  // }

  // method to add IncidentRiskArea
  addIncidentRiskArea(value: IncidentRiskAreaDto) {
    const control  = this.incidentRiskAreaFormArray.controls.IncidentRiskAreas as FormArray;
    control.insert(0,
          this.fb.group({
            RiskAreaName: value.RiskAreaName,
            RiskAreaDescription: value.RiskAreaDescription,
            IncidentEventTypeId: value.IncidentEventTypeId,
            EventName: this.EventName,
            id: null
          })
       );
  }

  selectIncidentRiskArea(value) {


  }

  getEventName(id: string) {
    const found = this.eventTypes.find(eventype => eventype.id === id);
   return found ? found.EventName : '';
  }

  // method to delete IncidentRiskArea from arrary list
  deleteIncidentRiskArea(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.incidentRiskAreaFormArray.controls.IncidentRiskAreas as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.incidentRiskAreas.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.incidentRiskArea[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IncidentRiskAreaDto) {
    if(this.incidentRiskAreaForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.incidentRiskAreaFormArray.get('IncidentRiskAreas')['controls'][this.selectedIndex].patchValue({
        // RiskAreaName: formValue.RiskAreaName,
        // RiskAreaDescription: formValue.RiskAreaDescription,
        // IncidentEventTypeId: formValue.IncidentEventTypeId,
        // EventName: this.EventName != null ? this.EventName : formValue.EventName,
       ...formValue
      });
    } else {
      this.addIncidentRiskArea(formValue);
    }
    this.selectedIndex = null;
    this.incidentRiskAreaForm.reset()
  }

  onEdit(index, value: IncidentRiskAreaDto) {
    this.selectedIndex = index;
    this.incidentRiskAreaForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentRiskAreaForm.reset();
  }

  onSubmit(formValue: IncidentRiskAreaDto[]) {
  this.incidentRiskArea.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteIncidentRiskAreaEvent.emit(this.filteredDelete);
  }
  }


}

